module.exports = __webpack_public_path__ + "img/error-02.48a1a9f6.png";